import { render, staticRenderFns } from "./TermsTap.vue?vue&type=template&id=441788b8"
import script from "./TermsTap.vue?vue&type=script&lang=js"
export * from "./TermsTap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports